import React, { useState, useEffect } from "react";

const Cards3 = ({ cards }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 800); 
    };

    window.addEventListener("resize", handleResize); 
    return () => window.removeEventListener("resize", handleResize); 
  }, []); 

  return (
    <div
      className={`grid gap-6 px-6 w-full ${
        isMobile ? "grid-cols-1 grid-rows-4 max-h-[1000px] max-w-[1000px]" : "md:grid-cols-3 md:grid-rows-2 md:max-h-[500px] max-w-[1000px]"
      }`}
    >
      {cards.map((card, index) => {
        let col = card.col;
        let row = card.row;
        let colspan = card.colSpan;
        let rowspan = card.rowSpan;

        if (isMobile) {
          col = 1;
          row = index +1; 
          colspan = 1;
          rowspan = 1;
        }

        return (
          <div
            key={index}
            className="relative group overflow-hidden rounded-xl"
            style={{
              gridColumn: `${col} / span ${colspan}`,
              gridRow: `${row} / span ${rowspan}`,
              maxWidth: "100%",
            }}
          >
            <img
              src={card.image}
              alt={card.title}
              className="object-cover w-full h-full transform transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-70"></div>
            <div className="absolute text-white inset-0 flex flex-col justify-end items-center text-center m-8">
              <h2 className="font-customFont1 text-3xl font-extrabold">{card.title}</h2>
              <p className="font-customFont2 text-lg font-light">{card.subtitle}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Cards3;
